export class LoadFinOpsAzureSubscriptionsHistoricalData {
    static type = '[FINPS][AZURE][SUBSCRIPTIONS] LoadFinOpsAzureSubscriptionsHistoricalData'
}

export class LoadDataTableFinOpsAzureSubscriptions {
    static type = '[FINPS][AZURE][SUBSCRIPTIONS] LoadDataTableFinOpsAzureSubscriptions'
}


export class LoadFinOpsAzureSubscriptionsChartsData {
    static type = '[FINPS][AZURE][SUBSCRIPTIONS] LoadFinOpsAzureSubscriptionsChartsData'
}

export class LoadFinOpsAzureSubscriptionsChartsFilteredData {
    static type = '[FINPS][AZURE][SUBSCRIPTIONS] LoadFinOpsAzureSubscriptionsChartsFilteredData'
}